/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".main-container[_ngcontent-%COMP%]{position:relative;height:100vh;overflow-y:scroll}.header[_ngcontent-%COMP%]{height:50px;max-height:50px}.profileIcon[_ngcontent-%COMP%]{padding-top:5px}.logoLink[_ngcontent-%COMP%]{background:url(logo.aba7c60aad45d0d33642.png) 0 0/contain no-repeat;display:block;width:100%;height:100%}\n/*# sourceMappingURL=main.component.css.map*/"];
export { styles as styles };
